export function CheckedIcon({ ...props }) {
  return (
    <svg
      width={14}
      height={14}
      viewBox="0 0 13 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.64 3.61a.375.375 0 0 1 0 .53L5.39 9.39a.375.375 0 0 1-.53 0L2.235 6.765a.375.375 0 1 1 .53-.53l2.36 2.36L10.11 3.61a.375.375 0 0 1 .53 0"
        fill="currentColor"
      />
    </svg>
  );
}
